import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import PatientCreateForm from "./-form";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Patient } from "@/requests/gen/react-query/fastAPI.schemas";
import { Button } from "@/components/ui/button";
import { PatientCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_patient-360/patient/create")({
  component: PatientCreatePage,
});

function PatientCreatePage() {
  const navigate = useNavigate();

  const onSuccessFn = (response: Patient) => {
    navigate({
      to: "/patient/$patientId/create/address",
      params: { patientId: String(response.patient_id) },
    });
  };

  return (
    <div>
      <title>Create Patient - Legrande Health Portal</title>
      <PatientCrumbs />

      {/* Patient form */}
      <Card>
        <CardHeader>
          <CardTitle>New Patient</CardTitle>
          <CardDescription>Enter patient details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <PatientCreateForm
            onSuccessFn={onSuccessFn}
            onCancelBtn={
              <Button variant="outline" asChild>
                <Link to="/patient/lookup">Cancel</Link>
              </Button>
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
